export default __webpack_public_path__ + "static/media/de.38382dc0.svg";